import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "$md"
});